/*
  Replaces Shopify's deprecated option_selection.js and api.jquery.js with just the parts this theme uses:
  formatMoney, resizeImage, uniq, getCart, getProduct, removeItem and OptionSelectors.
  OptionSelectors builds the same markup as the original (.selector-wrapper > .single-option-selector,
  ids "<select id>-option-N"), which swatch.liquid, linked-options.liquid and quickview rely on.
*/
(function() {
  var Shopify = window.Shopify = window.Shopify || {};

  function root() {
    return (Shopify.routes && Shopify.routes.root) || '/';
  }

  Shopify.formatMoney = function(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = format || Shopify.money_format || '${{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return 0;
      var parts = (number / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }

    var value = '';
    switch (format.match(placeholder)[1]) {
      case 'amount': value = withDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
    }
    return format.replace(placeholder, value);
  };

  // Legacy size suffixes ("grande", "1024x1024"): cdn.shopify.com still serves them.
  Shopify.resizeImage = function(image, size) {
    if (size === 'original') return image;
    var match = String(image).match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
    return match ? match[1] + '_' + size + '.' + match[2] : image;
  };

  Shopify.uniq = function(array) {
    return array.filter(function(value, i) { return array.indexOf(value) === i; });
  };

  function json(url, options) {
    return fetch(url, options).then(function(response) {
      if (!response.ok) throw new Error(url + ' ' + response.status);
      return response.json();
    });
  }

  Shopify.getCart = function(callback) {
    json(root() + 'cart.js').then(callback);
  };

  // Uses the current language's URL so quick view shows translated titles.
  Shopify.getProduct = function(handle, callback) {
    json(root() + 'products/' + handle + '.js').then(callback);
  };

  Shopify.removeItem = function(id, callback) {
    json(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: 0 })
    }).then(callback);
  };

  // options: { product, onVariantSelected(variant, selector, data), enableHistoryState }
  Shopify.OptionSelectors = function(selectId, options) {
    var self = this;
    var product = options.product;
    var original = document.getElementById(selectId);

    this.domIdPrefix = selectId;
    this.product = product;
    this.selectors = [];
    this.variantIdField = original;

    // Product JSON from Liquid has option names; the AJAX API has {name, values} objects.
    var names = product.options.map(function(option) { return typeof option === 'string' ? option : option.name; });

    names.forEach(function(name, index) {
      var select = document.createElement('select');
      select.className = 'single-option-selector';
      select.id = selectId + '-option-' + index;
      select.setAttribute('data-option', 'option' + (index + 1));
      Shopify.uniq(product.variants.map(function(variant) { return variant.options[index]; })).forEach(function(value) {
        var option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
      // A handler property, not addEventListener: jQuery's .trigger('change') (used by swatches and
      // linked options) calls onchange but doesn't dispatch a native event.
      select.onchange = function(event, data) { self.updateSelectors(data || {}); };

      var wrapper = document.createElement('div');
      wrapper.className = 'selector-wrapper';
      if (names.length > 1) {
        var label = document.createElement('label');
        label.htmlFor = select.id;
        label.textContent = name;
        wrapper.appendChild(label);
      }
      wrapper.appendChild(select);
      original.parentNode.insertBefore(wrapper, original);
      self.selectors.push(select);
    });
    original.style.display = 'none';

    this.enableHistoryState = !!options.enableHistoryState;
    this.onVariantSelected = options.onVariantSelected || function() {};

    var selected = original.querySelector('option[selected]');
    this.selectVariant(selected ? selected.value : product.variants[0].id, { initialLoad: true });
  };

  Shopify.OptionSelectors.prototype.selectVariant = function(variantId, data) {
    var variant = this.product.variants.filter(function(v) { return String(v.id) === String(variantId); })[0];
    if (!variant) return false;
    this.selectors.forEach(function(select, index) {
      var value = variant.options[index];
      if ([].some.call(select.options, function(option) { return option.value === value; })) select.value = value;
    });
    if (window.jQuery) jQuery(this.selectors[0]).trigger('change', data);
    else this.selectors[0].onchange(null, data);
    return true;
  };

  Shopify.OptionSelectors.prototype.updateSelectors = function(data) {
    var values = this.selectors.map(function(select) { return select.value; });
    var variant = this.product.variants.filter(function(v) {
      return values.every(function(value, i) { return v.options[i] === value; });
    })[0] || null;

    this.variantIdField.disabled = !variant;
    if (variant) this.variantIdField.value = variant.id;

    this.onVariantSelected(variant, this, data);

    if (this.enableHistoryState && variant && !data.initialLoad) {
      history.replaceState(history.state, '', location.pathname + '?variant=' + variant.id);
    }
  };
})();
